import { Link } from '@framework/router/Next/Link';
import TruncateText from '@creditflowresearch/uilib/TruncateText';

const NameCell = ({ row, cellData }) => (
  <TruncateText value={ cellData }>
    <Link to={ row.url } target="_blank">
      { cellData }
    </Link>
  </TruncateText>
);

export default NameCell;
